import { LoadingOverlay } from "@mantine/core";
import qs from "qs";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { AuthApi, GeneralApi } from "../../apis";
import { IAuth } from "../../interfaces/IAuth";
import { authChange, authMe } from "../../store/Auth";
import { initGeneral } from "../../store/General";

export function Access() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accessToken } = useSelector((state: { auth: IAuth }) => state.auth);

  React.useEffect(() => {
    (async () => {
      const params = qs.parse(location.search);
      dispatch(authChange({ accessToken: params["?token"], sessionScope: "AUTHORIZED" } as any));

      // Best-effort enrichment. A tenant-admin (CUSTOMER + tid, lgt=PARTNER) is rejected
      // by the STAFF-only /api/auth/me — that is expected, not an error to surface; the
      // session is already set above and App's resilient bootstrap re-fetches what works.
      try {
        const res = await GeneralApi.init();
        dispatch(initGeneral(res));
      } catch { /* partner-side init optional here */ }

      try {
        const auth = await AuthApi.me();
        dispatch(authMe(auth));
      } catch { /* STAFF /me 401s for tenant-admins by design */ }

      navigate("/");
    })();
  }, [accessToken, dispatch, location, navigate]);

  return <LoadingOverlay visible />;
}
